import React from 'react';
import CortadHistory from 'components/ColonyPopup/CortadHistory';

const ChatSstChart = ({ lat, lng, title }) => {
  const latitude = Number(lat);
  const longitude = Number(lng);
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;
  return (
    <div className="chat-sst-chart">
      <CortadHistory
        latitude={latitude}
        longitude={longitude}
        title={title || 'SST time series (CoRTAD v6)'}
      />
    </div>
  );
};

export default ChatSstChart;
